import { findNikkeInCatalog } from '../../nikke-catalog/domain/nikkeCatalog.js';

const text = (value) => String(value ?? '').trim();

function numberValue(value, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

function deckCode(item) {
  if (typeof item === 'string' || typeof item === 'number') return text(item);
  return text(item?.code ?? item?.nikke_id ?? item?.nikkeId ?? item?.tid ?? item?.id);
}

export function normalizeRaidOverviewDeck(deck, catalog = null) {
  return (Array.isArray(deck) ? deck : [])
    .map((item, index) => {
      const code = deckCode(item);
      if (!code) return null;
      const catalogItem = findNikkeInCatalog(catalog, item) || findNikkeInCatalog(catalog, code);
      const source = item && typeof item === 'object' ? item : {};
      return {
        code,
        slot: numberValue(source.slot, index + 1),
        level: numberValue(source.level ?? source.char_level ?? source.lv, 0) || null,
        nikkeId: text(source.nikkeId ?? source.nikke_id ?? catalogItem?.nikkeId),
        name: text(source.name ?? source.character_name ?? catalogItem?.name ?? catalogItem?.officialName ?? code),
        imageUrl: text(source.imageUrl ?? source.image_url ?? source.character_image_url ?? catalogItem?.imageUrl),
        element: text(source.element ?? catalogItem?.element),
        elementImageUrl: text(source.elementImageUrl ?? source.element_image_url ?? catalogItem?.elementImageUrl),
        burst: text(source.burst ?? catalogItem?.burst),
        burstCode: text(source.burstCode ?? source.burst_code ?? catalogItem?.burstCode),
        burstImageUrl: text(source.burstImageUrl ?? source.burst_image_url ?? catalogItem?.burstImageUrl),
      };
    })
    .filter(Boolean)
    .slice(0, 5);
}
